export const SUPER_ADMIN = 'SUPER_ADMIN'
export const ADMIN = 'ADMIN'
export const OFFICE_USER = 'OFFICE_USER'
export const MOBILE_USER = 'MOBILE_USER'
